import * as React from 'react';
import { selectClaims } from '../../slices/global/authSlice';
import { Alert, AlertTitle } from '@mui/material';
import { useAppSelector } from '../../hooks';

interface Props {
  children?: React.ReactNode;
  type: string;
  value: string;
  showAlert?: boolean;
  replacementChildren?: React.ReactNode;
}

export default function RestrictedAccess({
  children,
  type,
  value,
  showAlert = true,
  replacementChildren,
}: Props) {
  const claims = useAppSelector(selectClaims);

  return (
    <>
      {claims &&
      claims.filter((x) => x.type === type && x.value === value && x.isActive).length <= 0 ? (
        <>
          {replacementChildren
            ? replacementChildren
            : showAlert && (
                <Alert severity="warning" variant="outlined">
                  <AlertTitle>
                    <strong>Warning!</strong>
                  </AlertTitle>
                  This feature is currently unavailable, contact your Administrator for access.
                </Alert>
              )}
        </>
      ) : (
        children
      )}
    </>
  );
}
